module.exports = __webpack_public_path__ + "static/media/599.756(34).2c3a9192.pdf";